export const inputClassNames = (customHeight = '') =>
  `border-2 ${
    customHeight ? customHeight : 'min-h-12'
  } border-gray-300 text-gray-600 min-w-fill w-full px-2 py-2.5 bg-white rounded leading-6 transition transition-colors focus:border-primary focus:outline-none`
